var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex items-center justify-center p-8"},[_c('h6',{staticClass:"block text-base text-center w-100 text-slate-800 dark:text-slate-300"},[_c('span',{staticClass:"me-3"},[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('span',{staticClass:"spinner"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }